"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BADGE = void 0;
var BADGE;
(function (BADGE) {
    BADGE[BADGE["UNSET_BADGE"] = 0] = "UNSET_BADGE";
    BADGE[BADGE["STAR"] = 1] = "STAR";
    BADGE[BADGE["TICK"] = 2] = "TICK";
    BADGE[BADGE["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BADGE = exports.BADGE || (exports.BADGE = {}));
//# sourceMappingURL=constants.js.map